
import * as vercelRuntime$bFd1Rss_kuhPoknpoo3MGTLJbnbklKXjlM7k8wcJZks from '/vercel/path0/node_modules/.pnpm/@nuxt+image@https+++pkg.pr.new+@nuxt+image@1a5786c_@netlify+blobs@8.2.0_db0@0.3.2_bette_67232f9a1a38608f472892b340607eab/node_modules/@nuxt/image/dist/runtime/providers/vercel'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "vercel",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['vercel']: { provider: vercelRuntime$bFd1Rss_kuhPoknpoo3MGTLJbnbklKXjlM7k8wcJZks, defaults: {} }
}
        